// Link do formulário público de pesquisa de satisfação.
// Token: base64 url-safe de { a:audience, u:userId, id:clientId, p:partnerId, n:nome }.

export function encodePesquisaToken(obj) {
  try {
    return btoa(unescape(encodeURIComponent(JSON.stringify(obj || {}))))
      .replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  } catch { return ""; }
}
export function decodePesquisaToken(token) {
  try {
    const b = token.replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(decodeURIComponent(escape(atob(b))));
  } catch { return null; }
}
export function pesquisaUrl(token) {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  return `${origin}/?p=${token}`;
}
function convite(audience, nome) {
  const alvo = nome ? ` ${nome}` : "";
  return `Olá!${alvo} Sua opinião é muito importante para a InstaSolutions. Leva menos de 2 minutos para responder nossa pesquisa:`;
}
export function whatsappPesquisa(phone, token, audience, nome) {
  const text = `${convite(audience, nome)}\n${pesquisaUrl(token)}`;
  const d = String(phone || "").replace(/\D/g, "");
  const base = d ? `https://wa.me/${d.length <= 11 ? "55" + d : d}` : "https://wa.me/";
  return `${base}?text=${encodeURIComponent(text)}`;
}
export function emailPesquisa(token, audience, nome) {
  const subject = "Pesquisa de Satisfação — InstaSolutions";
  const body = `${convite(audience, nome)}\n${pesquisaUrl(token)}`;
  return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
